import React from 'react';
import './Toast.scss';

interface ToastProps {
  id: number;
  message: string;
  type: 'success' | 'error' | 'warning' | 'info';
  onClose: (id: number) => void;
  'data-placement'?: 'top' | 'bottom' | 'left' | 'right';
}

const Toast: React.FC<ToastProps> = ({ id, message, type, onClose, 'data-placement': placement }) => {
  return (
    <div className={`toast toast-${type}`} data-placement={placement}>
      <div className="toast-content">
        <span className="toast-message">{message}</span>
      </div>
      <button 
        className="toast-close" 
        onClick={() => onClose(id)}
        aria-label="Close toast"
      >
        ×
      </button>
    </div>
  );
};

export default Toast;